import { Tabs } from 'antd'
import React, { useState } from 'react'
import DepositReport from './depositReport';
import WithdrawalReport from './withdrawalReport';
import TransferReport from './transferReport';
import Logs from '../logs/logs';

function ReportsPage() {
    const [selectedTab, setSelectedTab] = useState('Deposit');

    return (
        <div>
            <div className="mb-2 bg-white rounded-lg shadow-sm py-2 px-3">
                <Tabs
                    activeKey={selectedTab}
                    onChange={setSelectedTab}
                    centered
                    size="large"
                    items={["Deposit", "Withdraw", "Transfer", "Logs"]?.map((type) => ({
                        key: type,
                        label: type,
                    }))}
                    className="custom-tabs mobile-account-tabs"
                />
            </div>

            {selectedTab === "Deposit" && <DepositReport />}
            {selectedTab === "Withdraw" && <WithdrawalReport />}
            {selectedTab === "Transfer" && <TransferReport />}
            {selectedTab === "Logs" && <Logs />}
        </div>
    )
}

export default ReportsPage
